import { Injectable } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, interval } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class UpdateProvider {

    hasUpdate: boolean = false

    private interval: any

    private static serviceWorkerRegistration: ServiceWorkerRegistration = null

    constructor(private swUpdate: SwUpdate, private _http: HttpClient) {

        const t = this
        swUpdate.versionUpdates.subscribe((evt: VersionEvent) => {
            if (evt.type == 'VERSION_READY') {
                this.hasUpdate = true
            }
            if (evt.type == 'NO_NEW_VERSION_DETECTED') {
                // Do nothing
            }
        })

        this.interval = interval(environment.updateInterval)
        this.interval.subscribe(() => {
            t.swUpdate.checkForUpdate().then((value: boolean) => {
                t.hasUpdate ||= value
            })
        })

        // const observable = new Observable<any>(observer => {
        //     if (typeof(navigator?.serviceWorker) !== 'undefined') {
        //         navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
        //             UpdateProvider.serviceWorkerRegistration = serviceWorkerRegistration
        //             observer.next()
        //         })
        //     }
        // })
        // observable.subscribe(() => {
        //     this.interval = interval(environment.updateInterval)
        //     this.interval.subscribe(() => {
        //         if (this.isSafari()) {
        //             this.safariCheckForUpdate()
        //         } else {
        //             swUpdate.checkForUpdate()
        //         }
        //         console.log('here')
        //     })
        // })
    }

    activateUpdate() {
        if (this.hasUpdate) {

            this.swUpdate.activateUpdate().then(() => {
                this.hasUpdate = false
                document.location.reload()
            }).catch(() => {
                document.location.reload()
            })


            // if (this.isSafari()) {
            //     this.safariActivateUpdate()
            // } else {
            //     this.swUpdate.activateUpdate().then(() => {
            //         this.hasUpdate = false
            //         document.location.reload()
            //     }).catch(() => {
            //         document.location.reload()
            //     })
            // }
        } else {
            document.location.reload()
        }
    }

    private safariCheckForUpdate() {
        if (this.isSafari()) {
            this._http.get(window.location.origin + '/ngsw.json?' + Math.random(), {observe: 'response'}).subscribe((r: HttpResponse<any>) => {
                // 1. Get existing sha from local storage
                // 2. If no current sha, simply add existing sha and call it happy
                // 3. If existing sha doesn't match current sha, show has update
                // 4. Delete

                const existingManifest = localStorage.getItem('manifest');
                const newManifest = r.body
                if (!existingManifest || existingManifest === '') {
                    // Assume no update, save the incoming one
                    localStorage.setItem('manifest', JSON.stringify(newManifest))
                } else {
                    // Check the two files for inconsistencies
                    const obj = JSON.parse(existingManifest)

                    if (Object.keys(obj.hashTable).length !== Object.keys(newManifest.hashTable).length) {
                        this.hasUpdate = true
                    }
                    Object.keys(newManifest.hashTable).forEach((key: string, index: number) => {
                        if (newManifest.hashTable[key] !== obj.hashTable[key]) {
                            this.hasUpdate = true
                        }
                    })
                    if (this.hasUpdate) {
                        localStorage.setItem('new_manifest', JSON.stringify(newManifest))
                    }
                }
            })
        }
    }

    private safariActivateUpdate() {
        const oldManifest = JSON.parse(localStorage.getItem('manifest')) || { hashTable: {}}  // I don't think it's possible for 'manifest' to be null or undefined, but just in case
        const newManifest = JSON.parse(localStorage.getItem('new_manifest'))

        if (newManifest) {
            // Kill some caches...
            window.caches.keys().then((values: string[]) => {
                values.forEach((cacheValue: string) => {
                    if (cacheValue.endsWith('assets:app:cache')) {
                        Object.keys(newManifest.hashTable).forEach((value: string, index: number) => {
                            if (newManifest.hashTable[value] !== oldManifest.hashTable[value]) {
                                // Remove this one from the caches...
                                window.caches.open(cacheValue).then(cache => {
                                    cache.delete(value)
                                });
                            }
                        })
                    }
                })
            })

            localStorage.setItem('manifest', localStorage.getItem('new_manifest'))
            localStorage.removeItem('new_manifest')
        }

        document.location.reload()
    }

    private isSafari(): boolean {
        const is_chrome = navigator.userAgent.indexOf('Chrome') > -1
        const is_safari = navigator.userAgent.indexOf('Safari') > -1
        return is_safari && !is_chrome
    }
}
